import { useState, useMemo } from "react";
import "./ProfileControls.css";
import { useMsal } from "@azure/msal-react";
import { useDataContext } from "../../../data-context/DataContextProvider";
import { useTranslation, SupportedLocale } from "@preppa/translation";
//SKAPA Components
import Combobox, { MenuItem } from "@ingka/combobox";
import Button from "@ingka/button";
//SKAPA Icons & Styles
import logOutIcon from "@ingka/ssr-icon/paths/arrow-right-from-base";
import "@ingka/svg-icon/dist/style.css";
import "@ingka/aspect-ratio-box/dist/style.css";
import "@ingka/image/dist/style.css";
import "@ingka/forms/dist/style.css";
import "@ingka/pill/dist/style.css";
import "@ingka/text/dist/style.css";
import "@ingka/list-view/dist/style.css";
import "@ingka/list-box/dist/style.css";
import "@ingka/combobox/dist/style.css";
import "@ingka/focus/dist/style.css";

function ProfileControls({ onStoreChange }: { onStoreChange: () => void }) {
  const { instance } = useMsal();
  const { storeOptions, selectStore, buCode, buType, isDeviceApp } = useDataContext();
  const { translate, locale, setLocale, locales } = useTranslation();
  
  const [selectedStore, setSelectedStore] = useState<{
    buCode: string;
    buType: string;
  } | null>(buCode ? { buCode, buType } : null);

  const handleStoreSelection = (selectedItems: string[]) => {
    if (selectedItems.length === 0) {
      setSelectedStore(null);
      return;
    }
    const buCode = selectedItems[0].replace("store-", "");
    const unit = storeOptions.find((u) => u.buCode === buCode);
    if (unit) {
      setSelectedStore({ buCode: unit.buCode, buType: unit.buType });
      selectStore(unit.buCode, unit.buType);
      onStoreChange();
    }
  };

  const handleLanguageSelection = (selectedItems: string[]) => {
    if (selectedItems.length === 0) return;
    const langCode = selectedItems[0].replace("lang-", "") as SupportedLocale;
    setLocale(langCode);
    localStorage.setItem("locale", langCode);
  };

  const storeValue = useMemo(
    () => (selectedStore ? [`store-${selectedStore.buCode}`] : []),
    [selectedStore?.buCode]
  );

  const languageValue = useMemo(() => [`lang-${locale}`], [locale]);

  return (
    <div className="profile-controls-wrapper">
      <label className="profile-controls-label">{translate("header.selectStore")}</label>
      <Combobox
        listboxId="store-select-listbox"
        labelId="store-select-label"
        placeholder={translate("header.selectStore")}
        value={storeValue}
        filtering
        disabled={isDeviceApp}
        onListBoxChange={handleStoreSelection}
      >
        {storeOptions.map((unit) => (
          <MenuItem
            key={unit.buCode}
            id={`store-${unit.buCode}`}
            title={unit.displayName}
          />
        ))}
      </Combobox>
      
      <label className="profile-controls-label">{translate("header.selectLanguage")}</label>
      <Combobox
        listboxId="language-select-listbox"
        labelId="language-select-label"
        placeholder={translate("header.selectLanguage")}
        value={languageValue}
        onListBoxChange={handleLanguageSelection}
      >
        {locales.map((langCode) => (
          <MenuItem
            key={langCode}
            id={`lang-${langCode}`}
            title={translate(`languages.${langCode}` as any)}
          />
        ))}
      </Combobox>
      
      <Button
        id="logout-button"
        ssrIcon={logOutIcon}
        text={translate("header.logout")}
        type="tertiary"
        onClick={() =>
          instance.logoutRedirect({
            postLogoutRedirectUri: window.location.origin,
          })
        }
      />
    </div>
  );
}

export default ProfileControls;
